<template>
  <div>
    <IconButton
      :tooltip="tooltip"
      :disabled="disabled"
      icon="fas fa-file-csv"
      color="green"
      float
      @click="download()"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object | Array,
      default: function () { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: 'Download as CSV'
    }
  },
  computed: {
    csv () {
      var csv, ctr, keys, columnDelimiter, lineDelimiter, data

      data = this.data || null
      if (data == null || !data.length) {
        return null
      }

      columnDelimiter = ','
      lineDelimiter = '\n'

      keys = Object.keys(data[0])

      csv = keys.join(columnDelimiter)
      csv += lineDelimiter

      data.forEach((item) => {
        ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) csv += columnDelimiter

          csv += item[key]
          ctr++
        })
        csv += lineDelimiter
      })

      return csv
    }
  },
  methods: {
    download () {
      var link = document.createElement('a')
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.csv))
      link.setAttribute('download', 'export.csv')
      link.click()
    }
  }
}
</script>
